// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__g3eXh {
  position: relative; }

.styles_actions__KjyJU {
  position: sticky;
  bottom: -0.18rem;
  background-color: #fff;
  padding-left: 0.5rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Text/TranslatableText/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB,EAAA;;AAGpB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB,EAAA","sourcesContent":[".container {\n  position: relative;\n}\n\n.actions {\n  position: sticky;\n  bottom: -0.18rem;\n  background-color: #fff;\n  padding-left: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__g3eXh`,
	"actions": `styles_actions__KjyJU`
};
export default ___CSS_LOADER_EXPORT___;
